import { GavelIcon } from './GavelIcon';

/**
 * author: Austin Andrews
 * id AB600896-534E-4A82-8E7F-99E0F22B54AE
 * name gavel
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gavel.svg
 * tags
 */
export const CourtHammerIcon = GavelIcon;
export default CourtHammerIcon